import { initializeApp } from 'firebase/app';
import { getMessaging, onMessage, type MessagePayload } from 'firebase/messaging';
import { onBackgroundMessage } from '@firebase/messaging/sw';
import { getAnalytics } from 'firebase/analytics';
import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin(() => {
    const app = initializeApp({
      apiKey: "AIzaSyDF6Y1hRfHyw0y2ivKN1FPc0SswHJoUTG0",
      authDomain: "pergiyuksgen1.firebaseapp.com",
      projectId: "pergiyuksgen1",
      storageBucket: "pergiyuksgen1.firebasestorage.app",
      messagingSenderId: "725943385723",
      appId: "1:725943385723:web:0ac3b1cd41356e5e7c6cde",
      measurementId: "G-X4EZLNXQW1"
    });
  
    const messaging = getMessaging(app);
    // const analytics = getAnalytics(app);

    const onMessageListener = (callback: (arg0: MessagePayload) => void) => {
      onMessage(messaging, (payload) => {
        console.log('Message received:', payload);
        callback(payload);
      });
    };
  
    return {
      provide: {
        messaging,
        onMessageListener
      },
    };
  });
  
